export function readFileAsBase64Payload(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Nem sikerült beolvasni a fájlt.'));
        return;
      }
      const comma = result.indexOf(',');
      const base64 = comma >= 0 ? result.slice(comma + 1) : result;
      resolve({
        filename: file.name || 'attachment',
        contentType: file.type || 'application/octet-stream',
        data: base64,
      });
    };
    reader.onerror = () => reject(new Error('Nem sikerült beolvasni a fájlt.'));
    reader.readAsDataURL(file);
  });
}

export function getQuoteInquiryApiBase() {
  return (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8003').replace(/\/$/, '');
}

export function emailWarningsFromInquiryResponse(data) {
  const parts = [];
  if (data?.emails?.office && !data.emails.office.ok) {
    parts.push(
      data.emails.office.error
        ? `Iroda értesítés: ${data.emails.office.error}`
        : 'Az iroda értesítő e-mail nem küldhető el.',
    );
  }
  if (data?.emails?.customer && !data.emails.customer.ok) {
    parts.push(
      data.emails.customer.error
        ? `Visszaigazolás: ${data.emails.customer.error}`
        : 'A visszaigazoló e-mail nem küldhető el.',
    );
  }
  return parts.length ? parts.join(' ') : '';
}

/**
 * @param {{ payload: Record<string, unknown>, timeoutMs?: number }} opts
 */
export async function postQuoteInquiry(opts) {
  const { payload, timeoutMs } = opts;
  const apiBase = getQuoteInquiryApiBase();
  const attachmentUploads = Array.isArray(payload.attachmentUploads) ? payload.attachmentUploads : [];
  const controller = new AbortController();
  const t = timeoutMs ?? (attachmentUploads.length ? 120000 : 15000);
  const timeoutId = setTimeout(() => controller.abort(), t);
  try {
    const response = await fetch(`${apiBase}/api/inquiries`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data?.error || 'Nem sikerült elküldeni az árajánlatkérést.');
    return data;
  } finally {
    clearTimeout(timeoutId);
  }
}
